import { Box, Link, Typography } from '@mui/material';
import React from 'react';
import { useAuth } from '../../contexts/auth';

const PaymentInfo = ({ paymentMethod }) => {
  const { user } = useAuth();

  return (
    <Box
      sx={{
        backgroundColor: 'background.paper',
        borderRadius: 2,
        padding: 3,
        marginY: 2,
        boxShadow: 1,
      }}
    >
      {paymentMethod === 'BANK_CARD' && (
        <>
          <Typography variant='body1' textAlign='justify' color='text.primary'>
            Bankkártyás fizetést választottál. Ebben az esetben átirányítunk a
            Barion oldalára, ahol a megszokott módon tudod kiegyenlíteni a
            szolgáltatás díját. A sikeres fizetést követően e-mailben küldünk
            számlát a szolgáltatásról.
          </Typography>
          <Typography
            variant='subtitle3'
            textAlign='justify'
            color='text.warning'
          >
            Kérlek erősítsd meg szándékodat, hogy elő szeretnél fizetni a
            havonta megújuló tagságra és megismerted az
            <Link
              href={process.env.PUBLIC_URL + '/aszf'}
              target='_blank'
              rel='noopener noreferrer'
              sx={{ mx: 1 }}
            >
              Általános Szerződési Feltételeket
            </Link>
          </Typography>
        </>
      )}

      {paymentMethod === 'BANK_TRANSFER' && (
        <>
          <Typography
            variant='body1'
            textAlign='justify'
            color='text.primary'
            mb={2}
          >
            Átutalás esetén a vásárlás gombra kattintva egy díjbekérőt küldünk a
            regisztrációkor megadott e-mail címedre{' '}
            <strong>({user?.userData?.user?.email})</strong>. Ebben minden
            információt megtalálsz a fizetéssel kapcsolatban.
          </Typography>
          <Typography
            variant='body1'
            textAlign='justify'
            color='text.secondary'
          >
            Amint a díjbekérő kiegyenlítésre került, rendszerünk azonnal
            bekapcsolja a szolgáltatásokat és kiállítjuk a számlát. A fizetéssel
            kapcsolatban felmerülő kérdés vagy probléma esetén keress minket a
            megadott elérhetőségeinken. Az átutalásos fizetés után a
            szolgáltatást általában legkésőbb 24 órán belül aktiváljuk.
          </Typography>
        </>
      )}
    </Box>
  );
};

export default PaymentInfo;
